var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activate-account"},[_vm._l((_vm.messages),function(message,i){return _c('v-alert',{key:i,staticClass:"ma-auto",attrs:{"type":_vm.messages.type,"width":"500"}},[_vm._v(" "+_vm._s(message)+" ")])}),_c('PageInformationText',{on:{"showPageInformationText":function($event){_vm.showPageInformationText = true}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }